"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnPlotRequiresUpdate = void 0;
const plot_1 = require("../plot");
/**
 * @public
 * Used to indicate that a redraw is required, which is performed by {@link IChartComponent.updateOnNextFrame}. Multiple
 * calls will be rolled up into a single update.
 */
class OnPlotRequiresUpdate {
    constructor(onPlotRequiresUpdate) {
        this.onPlotRequiresUpdate = onPlotRequiresUpdate;
    }
    static registerListener(eventService, onEvent) {
        return eventService
            .getCategory(OnPlotRequiresUpdate)
            .addTemporaryListener(new OnPlotRequiresUpdate(onEvent));
    }
    static emit(plot, updateFlag) {
        const listeners = plot_1.Plot
            .getChartEventService(plot)
            .getCategory(OnPlotRequiresUpdate)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onPlotRequiresUpdate(plot, updateFlag);
        }
    }
}
exports.OnPlotRequiresUpdate = OnPlotRequiresUpdate;
OnPlotRequiresUpdate.callbackKey = "onPlotRequiresUpdate";
//# sourceMappingURL=on-plot-requires-update.js.map